import React, { useState, useEffect } from 'react';
import BrandBadgeIcon from '../../../assets/icons/icon_brand_badge.svg';
import { fetchBrands } from '../../../api/searchServices';
import { Brand } from '../../../types/searchType';

interface SearchBrandAccountsProps {
  filter?: string;
}

const SearchBrandAccounts: React.FC<SearchBrandAccountsProps> = ({ filter }) => {
  const [brands, setBrands] = useState<Brand[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadBrands = async () => {
      try {
        const fetchedBrands = await fetchBrands();
        setBrands(fetchedBrands);
        setLoading(false);
      } catch (err) {
        setError('Failed to load brands');
        setLoading(false);
      }
    };

    loadBrands();
  }, []);

  const filteredBrands = filter
    ? brands.filter(brand => 
        brand.brand_name.toLowerCase().includes(filter.toLowerCase())
      )
    : brands;

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return (
    <ul className="account-list">
      {filteredBrands.map(brand => (
        <li key={brand.id} className="account-item">
          <img src={brand.profile_picture} alt={brand.brand_name} className="account-avatar" />
          <span className="account-name">
            {brand.brand_name}
            <img src={BrandBadgeIcon} alt="Brand" className="brand-badge" />
          </span>
          <button className="collabs-button">Collabs</button>
        </li>
      ))}
    </ul>
  );
};

export default SearchBrandAccounts;
